import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiUrlService} from "./api-url.service";
import {DienststellenVorbelegung} from "../../model/dienststellen-vorbelegung";
import {DienststellenSearchResult} from "../../model/dienststellen-search-result";
import {Dienststelle} from "../../model/dienststelle";

@Injectable({
    providedIn: 'root' // ✅ Ensures the service is available globally
})
export class DienststellenService {
    private readonly http: HttpClient = inject(HttpClient);
    private apiUrlService = inject(ApiUrlService);

    public getDienststellenVorbelegung(): Observable<DienststellenVorbelegung> {
        return this.http.get<DienststellenVorbelegung>(`${this.apiUrlService.getApiUrl()}/dienststellen/vorbelegung`);
    }

    public getDienststellenList(): Observable<DienststellenSearchResult[]> {
        return this.http.get<DienststellenSearchResult[]>(`${this.apiUrlService.getApiUrl()}/dienststellen/jobcenterview`);
    }

    public getDienststelle(dienststellenNummer:string): Observable<Dienststelle> {
        return this.http.get<Dienststelle>(`${this.apiUrlService.getApiUrl()}/dienststellen/${dienststellenNummer}`);
    }
}